<template>
  <div>
    <Main
      :height="height"
      :loading="loading"
      :tableData="tableData"
      :type="type"
      ref="tableMain"
    >
      <div slot="header">
        <b-row align-h="between">
          <b-col cols="7">
            <b-form onsubmit="return false">
              <b-input-group size="sm">
                <b-form-input
                  @keyup.enter="getData"
                  type="search"
                  v-model.trim="keyword"
                  :placeholder="
                    $l('form_label_good_search') ||
                      '成品编码/子件编码/产品名称/颜色/规格 搜索...'
                  "
                />
                <b-input-group-append>
                  <b-button-group>
                    <b-button-group slot="reference">
                      <b-button variant="primary" size="sm" @click="getData">
                        <i class="fa fa-search" />
                      </b-button>
                    </b-button-group>
                  </b-button-group>
                </b-input-group-append>
              </b-input-group>
            </b-form>
          </b-col>
        </b-row>
      </div>
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: {
    Main,
  },
  props: {
    height: { type: Number, default: 300 },
    orderCode: { type: String, default: '' },
    orderTechPricingCode: { type: String, default: '' },
    orderTechPricingSpecCode: { type: String, default: '' },
    type: { type: String, default: 'radio' },
  },
  data() {
    return {
      loading: false,
      keyword: '',
      tableData: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData(form) {
      if (!this.orderCode) return
      this.loading = true
      this.$api
        .orderTechPricingGoodsListApi({
          orderCode: this.orderCode,
          orderTechPricingCode: this.orderTechPricingCode,
          orderTechPricingSpecCode: this.orderTechPricingSpecCode,
          ...form,
          keyword: this.keyword,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
    choiceData() {
      return this.$refs.tableMain.choiceData()
    },
  },
}
</script>
